// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b2cbb0c4] .color{min-width:100px;padding-top:0}[data-v-b2cbb0c4] .color input{padding:4px!important}[data-v-b2cbb0c4] .color .v-input__slot:after,[data-v-b2cbb0c4] .color .v-input__slot:before{display:none!important}[data-v-b2cbb0c4] .v-application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot{min-width:100px!important}", ""]);
// Exports
module.exports = exports;
